export const treeLevelHide = (tree: any,showLeaf: any) => {
  function checkAnyTreeLevelHide(accountList:any){
    if(accountList["children"] && accountList["children"].length > 0){
      accountList["children"].forEach ((child: any,index:any) => {
        if(child.isHidden){
          delete accountList["children"][0];
          accountList = IsTreeLevelHide(accountList,child);
          accountList["children"] = accountList["children"].filter((e:any)=>e);
        }else if(child.leaf && !showLeaf){
          accountList.leaf = true;
          delete accountList["children"][0];
          accountList["children"] = accountList["children"].filter((e:any)=>e);
        }
      });
      accountList["children"].forEach ((child: any) => checkAnyTreeLevelHide(child));
      return accountList;
    }
  }



  // function IsTreeLevelHide(parentNode:any,treeNode:any){
  //   if(treeNode["children"] && treeNode["children"][0].isHidden){
  //     treeNode["children"].forEach((child:any)=>IsTreeLevelHide(parentNode,child));
  //   }else{
  //     parentNode["children"].push(...treeNode["children"])
  //   }
  //   return parentNode;
  // }


  function IsTreeLevelHide(parentNode:any,treeNode:any){

    if(treeNode.isHidden ){
      treeNode["children"].forEach((child:any)=>IsTreeLevelHide(parentNode,child));
    }else{
      parentNode["children"].push(treeNode)
    }
    return parentNode;
  }


  let dataArray = {
    children:tree
  }
  dataArray = checkAnyTreeLevelHide(dataArray);
  tree = dataArray["children"];
  return tree;
}
